import React from 'react';

import LoaderWithText from '@components/loading/LoaderWithText';

import './Loader.scss';

interface Props {
    title: string;
}

export const AppLoader = ({ title }: Props) => (
    <div className="loader-wrapper">
        <LoaderWithText title={title} />
    </div>
);
